import { Card, CardContent, CardMedia, Container, Grid, Typography } from '@mui/material';
import img0 from '../../utils/images/aboutUs.jfif';
import img1 from '../../utils/images/aboutUs1.JPG';
import img2 from '../../utils/images/aboutUs2.jfif';
import img3 from '../../utils/images/uwp-3.jpg';
import img4 from '../../utils/images/uwp-4.jpg';
import img6 from '../../utils/images/uwp-6.jpg';
import uwp7 from '../../utils/images/uwp-7.jpg';
import uwp8 from '../../utils/images/uwp-8.jpg';

import React from 'react';
import { Navbar } from '../../components/Navbar/Navbar';
import { Box } from '@mui/system';
// import Ticker from 'react-ticker';
import Ticker from '../../components/Tickers/Tickers';
import Footer from '../../components/Footer/Footer';
import Tickers from '../../components/Tickers/Tickers';

const Events = () => {
  return (
    <div>
      <Navbar />
      {/* <Ticker>
        {({ index }) => (
          <>
            <div style={{ backgroundColor: '#FF7345', marginTop: '70px', color: 'white' }}>
              <Typography sx={{ fontFamily: 'Sora', marginRight: 2 }}>
                Sample News <></>
              </Typography>
            </div>
          </>
        )}
      </Ticker> */}
      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          height: '457px',
          paddingTop: '100px',
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: 'cover',
          position: 'relative',
          backgroundPosition: 'center',
          zIndex: -1,
          flexDirection: 'column',
          backgroundBlendMode: 'darken',

          // marginTop: '20px',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Poppins',
            color: '#FFFFFF',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            marginTop: '100px',
            fontWeight: 'bold',
            fontSize: '3.2rem',
          }}
        >
          Events
        </Typography>
        {/* <Typography
          variant="h4"
          sx={{
            fontFamily: 'Sora',
            color: 'white',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            fontWeight: 'bold',
            fontSize: ['20px', '30px', '30px'],
          }}
        >
          Know About Our Upcoming Events
        </Typography> */}
      </div>
      {/* <Typography
        variant="h5"
        sx={{
          display: "flex",
          width: "100%",
          fontFamily: "Sora",
          justifyContent: "center",
          color: "#FF7345",
          fontWeight: "bold",
          marginTop: 4
        }}
      >
        Upcoming Events
      </Typography> */}
      <Box sx={{ flexGrow: 1, px: [0, 0, 20], paddingTop: 4, backgroundColor: '#fcfcfc' }}>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
          <Grid item xs={12} sm={12} md={4} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                width: '519px',
                marginRight: 1,
                overflow: 'auto',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px', display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <div>
                <CardContent sx={{}}>
                  <Typography
                    sx={{
                      color: '#ed7632',
                      fontSize: '17px',
                      fontFamily: 'Poppins',
                      backgroundColor: '#fef7f3',
                      borderRadius: '22px',
                      padding: '7px 14px',
                      marginTop: '20px',
                      height: '41px',
                      width: '70%',
                      textAlign: 'center',
                    }}
                  >
                    November 09, 2022
                  </Typography>
                  <Typography sx={{ color: '#151515', fontFamily: 'Poppins', marginTop: '18px', fontWeight: 'bold' }}>
                    University Wellness Program Post Graduate Research Poster Exhibits
                  </Typography>
                  {/* <Typography
                    sx={{
                      color: ' #62392B',
                      fontFamily: 'Poppins',
                      fontSize: '17px',
                      marginTop: '10px',
                    }}
                  >
                    The School of Public Health will be observing this day with various activities as an opportunity to
                    raise awareness and promote action through proven means.
                  </Typography> */}
                </CardContent>
              </div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={4} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                width: '519px',
                marginRight: 1,
                overflow: 'auto',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px', display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <div>
                <CardContent sx={{}}>
                  <Typography
                    sx={{
                      color: '#ed7632',
                      fontSize: '17px',
                      fontFamily: 'Poppins',
                      backgroundColor: '#fef7f3',
                      borderRadius: '22px',
                      padding: '7px 14px',
                      marginTop: '20px',
                      height: '41px',
                      width: '70%',
                      textAlign: 'center',
                    }}
                  >
                    November 15-17, 2022
                  </Typography>
                  <Typography sx={{ color: '#151515', fontFamily: 'Poppins', marginTop: '18px', fontWeight: 'bold' }}>
                    International Conference on ‘Higher Education Institutes’ Challenges and Solutions to Sustainable
                    Development Goals, 2022
                  </Typography>
                  <Typography
                    sx={{
                      color: ' #62392B',
                      fontFamily: 'Poppins',
                      fontSize: '17px',
                      marginTop: '10px',
                    }}
                  >
                    SDG#3 (Good Health and Well-being) – SVASTHYA being coordinated by SPH – Online Platform
                  </Typography>
                </CardContent>
              </div>
            </Card>
          </Grid>
          {/* <Grid item xs={12} sm={12} md={4} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                width: '519px',
                marginRight: 1,
                overflow: 'auto',
              }}
            > */}
          {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px', display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
          {/* <div>
                <CardContent sx={{}}>
                  <Typography
                    sx={{
                      color: '#ed7632',
                      fontSize: '17px',
                      fontFamily: 'Poppins',
                      backgroundColor: '#fef7f3',
                      borderRadius: '22px',
                      padding: '7px 14px',
                      marginTop: '20px',
                      height: '41px',
                      width: '50%',
                      textAlign: 'center',
                    }}
                  >
                    Nov 15-17, 2022
                  </Typography>
                  <Typography sx={{ color: '#151515', fontFamily: 'Poppins', marginTop: '18px', fontWeight: 'bold' }}>
                    International Conference on Sustainable Development Goals
                  </Typography>
                  <Typography
                    sx={{
                      color: ' #62392B',
                      fontFamily: 'Poppins',
                      fontSize: '17px',
                      marginTop: '10px',
                    }}
                  >
                    SRM Institute of Science and Technology will be conducting an International Conference on
                    Sustainable Development Goals (SDGs).
                  </Typography>
                </CardContent>
              </div> */}
          {/* </Card> */}
          {/* </Grid> */}
        </Grid>
      </Box>

      <Box sx={{ flexGrow: 1, px: [0, 0, 10], paddingTop: 4, backgroundColor: '#FCFCFC' }}>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
          {/* {Array.from(Array(0)).map((_, index) => (                  //100th to 104th line of code was commented
            <Grid item xs={12} sm={12} md={6} key={index} sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <Card
                sx={{ marginBottom: 2, boxShadow: '0px 3px 45px #00000008', height: '505px', width: '535px', borderRadius: '9px', paddingX: '10px' }}
              >
                <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container>
                <CardMedia
                  component="img"
                  height="254"
                  width="100%"
                  image={img3}
                  alt="Event" />

                <CardContent>

                  <div
                    style={{
                      display: "flex",
                    }}>
                    <div>
                      <Typography sx={{
                        color: "#ED7632",
                        fontFamily: 'Poppins',
                        marginLeft: "46.5px",
                        marginTop: "38px",
                        fontWeight: "bold",
                        fontSize: "21px",
                        justifyContent: "center"

                      }}>12th June</Typography>

                      <Typography sx={{
                        color: "#151515",
                        fontFamily: 'Poppins',
                        // marginLeft: "55px",
                        fontSize: "17px",
                        justifyContent: "center"
                      }}>11:30 AM</Typography>
                    </div>
                    <div
                      style={{
                        height: "95px",
                        border: "1px solid #DE7D43",
                        opacity: "0.44",
                        marginLeft: "34.6px",
                        marginTop: "26px"
                      }}></div>
                    <div>
                      <Typography sx={{
                        color: "#151515",
                        fontFamily: 'Poppins',
                        paddingLeft: "46.5px",
                        marginTop: "38px",
                        fontWeight: "bold",
                        fontSize: "21px",
                        justifyContent: "center"
                      }}>Lorem Ipsum Dolor Event</Typography>

                      <Typography sx={{
                        color: "#151515",
                        fontFamily: 'Poppins',
                        paddingLeft: "46.5px",
                        fontSize: "17px",
                        justifyContent: "center"
                      }}>Hosted By:<br /> Department of Lorem</Typography>
                    </div>
                  </div>
                  <Typography
                    sx={{
                      color: ' #151515',
                      fontFamily: 'Poppins',
                      textAlign: "left",
                      fontSize: '17px',
                      marginTop: '29px'
                    }}
                  >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))} */}

          <Grid item xs={12} sm={12} md={6} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                height: '505px',
                width: '535px',
                borderRadius: '9px',
                paddingX: '10px',
                overflow: 'scroll',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <CardMedia component="img" height="254" width="100%" image={uwp7} alt="Event" />

              <CardContent>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: '#ED7632',
                        fontFamily: 'Poppins',
                        // marginLeft: "46.5px",
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '21px',
                        justifyContent: 'center',
                        textAlign: 'justify',
                      }}
                    >
                      28th July
                    </Typography>

                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        // marginLeft: "55px",
                        fontSize: '17px',
                        justifyContent: 'center',
                        marginTop: '5px',
                      }}
                    >
                      {/* 12:00 - 3:00 pm */}
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: '95px',
                      border: '1px solid #DE7D43',
                      opacity: '0.44',
                      marginLeft: '34.6px',
                      marginTop: '26px',
                    }}
                  ></div>
                  <div>
                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        justifyContent: 'center',
                      }}
                    >
                      HEPATITIS CAN’T WAIT; BRINGING HEPATITIS CARE CLOSER!
                    </Typography>

                    {/* <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        fontSize: '17px',
                        justifyContent: 'center',
                      }}
                    >
                      Hosted By:
                      <br /> Department of Lorem
                    </Typography> */}
                  </div>
                </div>
                <Typography
                  sx={{
                    color: ' #151515',
                    fontFamily: 'Poppins',
                    textAlign: 'left',
                    fontSize: '17px',
                    marginTop: '25px',
                  }}
                >
                  World Hepatitis day, on July 28 observed annually each year to raise awareness of the burden of
                  Hepatitis B and C worldwide and come together to re-commit to achieving Hepatitis B (HBV) and
                  Hepatitis C (HCV) elimination goals. The theme for this year’s campaign is “I Can’t Wait”. On the
                  occasion of the same, SRM SPH students conducted an awareness rally at Anjur village on July 27, 2022
                  and helped the community members understand all about hepatitis. In-addition, our students organised
                  an awareness session at Government Higher Secondary School, Anjur and interacted with the school
                  children on the various types of hepatitis, the ways by which it transmits and the precautionary
                  measures to prevent the risk of transmission.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                height: '505px',
                width: '535px',
                borderRadius: '9px',
                paddingX: '10px',
                overflow: 'scroll',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <CardMedia component="img" height="254" width="100%" image={img4} alt="Event" />

              <CardContent>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: '#ED7632',
                        fontFamily: 'Poppins',
                        // marginLeft: "46.5px",
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '21px',
                        justifyContent: 'center',
                        textAlign: 'justify',
                      }}
                    >
                      3rd August
                    </Typography>

                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        // marginLeft: "55px",
                        fontSize: '17px',
                        justifyContent: 'center',
                        marginTop: '5px',
                      }}
                    >
                      {/* 10:00am - 3:00pm */}
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: '95px',
                      border: '1px solid #DE7D43',
                      opacity: '0.44',
                      marginLeft: '34.6px',
                      marginTop: '26px',
                    }}
                  ></div>
                  <div>
                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        justifyContent: 'center',
                      }}
                    >
                      LET’S STEP-UP TOGETHER FOR BREASTFEEDING!
                    </Typography>

                    {/* <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        fontSize: '17px',
                        justifyContent: 'center',
                      }}
                    >
                      Hosted By:
                      <br /> Department of Lorem
                    </Typography> */}
                  </div>
                </div>
                <Typography
                  sx={{
                    color: ' #151515',
                    fontFamily: 'Poppins',
                    textAlign: 'left',
                    fontSize: '17px',
                    marginTop: '25px',
                  }}
                >
                  World Breastfeeding Week is being celebrated during the first week of August every year. SRM School of
                  Public Health (SPH) commemorated the ‘World Breastfeeding Week’ on August 03, 2022 based on this
                  year’s campaign theme, ‘Let’s step up, educate and support breastfeeding’. SPH students actively
                  participated in the celebration through poster presentation, poetry writing and short film making and
                  exhibited their support for the creation of a breastfeeding friendly environment. On this occasion,
                  our students interacted with Mr. Sourav Bhattacharjee, Nutrition Specialist at UNICEF which created an
                  opportunity to reiterate their roles for doing every effort in the promotion and support of
                  breastfeeding.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                height: '505px',
                width: '535px',
                borderRadius: '9px',
                paddingX: '10px',
                overflow: 'scroll',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <CardMedia component="img" height="254" width="100%" image={img6} alt="Event" />

              <CardContent>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: '#ED7632',
                        fontFamily: 'Poppins',
                        // marginLeft: "46.5px",
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '21px',
                        justifyContent: 'center',
                        textAlign: 'justify',
                      }}
                    >
                      1st October
                    </Typography>

                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        // marginLeft: "55px",
                        fontSize: '17px',

                        justifyContent: 'center',
                        marginTop: '5px',
                      }}
                    >
                      {/* 10:00am -12:30pm & 1:30pm - 3:00pm */}
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: '95px',
                      border: '1px solid #DE7D43',
                      opacity: '0.44',
                      marginLeft: '34.6px',
                      marginTop: '26px',
                    }}
                  ></div>
                  <div>
                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        justifyContent: 'center',
                      }}
                    >
                      INTERNATIONAL DAY FOR OLDER PERSONS
                    </Typography>

                    {/* <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        fontSize: '17px',
                        justifyContent: 'center',
                      }}
                    >
                      Hosted By:
                      <br /> Department of Lorem
                    </Typography> */}
                  </div>
                </div>
                <Typography
                  sx={{
                    color: ' #151515',
                    fontFamily: 'Poppins',
                    textAlign: 'left',
                    fontSize: '17px',
                    marginTop: '25px',
                  }}
                >
                  A special day for elderly people was observed on October 01, 2022 every year. SPH commemorated
                  International Day for Older Persons on September 28, 2022 to stand up towards ageism and to encourage
                  the growth of a community that is accommodating to people of all ages. Students took part in Debate,
                  Just a Minute (JAM) and Short film making to raise awareness of the opportunities and challenges of
                  ageing in today’s world.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Card
              sx={{
                marginBottom: 2,
                boxShadow: '0px 3px 45px #00000008',
                height: '505px',
                width: '535px',
                borderRadius: '9px',
                paddingX: '10px',
                overflow: 'scroll',
              }}
            >
              {/* <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container> */}
              <CardMedia component="img" height="254" width="100%" image={uwp8} alt="Event" />

              <CardContent>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <div>
                    <Typography
                      sx={{
                        color: '#ED7632',
                        fontFamily: 'Poppins',
                        // marginLeft: "46.5px",
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '21px',
                        justifyContent: 'center',
                        textAlign: 'justify',
                      }}
                    >
                      28th September
                    </Typography>

                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        // marginLeft: "55px",
                        fontSize: '17px',

                        justifyContent: 'center',
                        marginTop: '5px',
                      }}
                    >
                      {/* 10:00am -12:30pm & 1:30pm - 3:00pm */}
                    </Typography>
                  </div>
                  <div
                    style={{
                      height: '95px',
                      border: '1px solid #DE7D43',
                      opacity: '0.44',
                      marginLeft: '34.6px',
                      marginTop: '26px',
                    }}
                  ></div>
                  <div>
                    <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        marginTop: '38px',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        justifyContent: 'center',
                      }}
                    >
                      FLASHMOB on Road Safety Awareness
                    </Typography>

                    {/* <Typography
                      sx={{
                        color: '#151515',
                        fontFamily: 'Poppins',
                        paddingLeft: '46.5px',
                        fontSize: '17px',
                        justifyContent: 'center',
                      }}
                    >
                      Hosted By:
                      <br /> Department of Lorem
                    </Typography> */}
                  </div>
                </div>
                <Typography
                  sx={{
                    color: ' #151515',
                    fontFamily: 'Poppins',
                    textAlign: 'left',
                    fontSize: '17px',
                    marginTop: '25px',
                  }}
                >
                  On September 28, 2022, SPH students performed a flash mob to create awareness about road safety and
                  wearing helmets. The performance reiterated the students about safe practices to be followed while on
                  road including the pillion riders to wear the helmets and following road safety rules.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </div>
  );
};

export default Events;
